export const normalizedAdvancedSettingsData = (data) => {
  return {
    hideProductSettings: {
      redirect: data.hideProductRedirect,
      customRedirectUrl: data.hideProductCustomRedirectURL,
      isActiveTags: data.hideProductIsActiveTags,
      selectedTags: data.hideProductSelectedTags,
      specificShopifyPage: data.hideProductSpecificShopifyPage,
      specificShopifyBlog: data.hideProductSpecificShopifyBlog,
      specificProductPage: data.hideProductSpecificProductPage
    },
    downProductSettings: {
      isActiveTags: data.downProductIsActiveTags,
      selectedTags: data.downProductSelectedTags
    },
    backProductSettings: {
      isActiveVisibleTags: data.backProductIsActiveVisibleTags,
      isActiveExcludeTags: data.backProductIsActiveExcludeTags,
      visibleSelectedTags: data.backProductVisibleSelectedTags,
      excludeSelectedTags: data.backProductExcludeSelectedTags
    },
    locationSettings: {
      monitorAllLocations: data.locationSettings?.monitorAllLocations ?? true,
      selectedLocationIds: data.locationSettings?.selectedLocationIds ?? [],
      selectedLocationNames: data.locationSettings?.selectedLocationNames ?? [],
    }
  }
}